import { useState } from 'react'
import { Box } from '@mui/material'
import { Formik, Form } from 'formik'
import { useTranslation } from 'react-i18next'

import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import ButtonSecondary from 'src/components/shared/ui/ButtonSecondary'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { RepresentanteProcesal } from 'src/interfaces/EscritosLegales'
import RequiredText from '../../../RequiredText'
import RepresentanteProcesalFormField from './RepresentanteProcesalFormFields'
import { validationSchema, initialValues } from './types'

type Props = {
  closeDialog: () => void
  getFormValues: (values: RepresentanteProcesal) => void
  formValues?: RepresentanteProcesal | null
}
export default function RepresentanteProcesalForm({
  closeDialog,
  getFormValues,
  formValues
}: Props): JSX.Element {
  const { t } = useTranslation()
  const [disabledAddBtn, setDisabledAddBtn] = useState(false)
  const { isMonitorio } = useTipoMensajeContext()
  const [validateAfterSubmit, setValidateAfterSubmit] = useState(false)

  function handleSubmit(values: RepresentanteProcesal) {
    setDisabledAddBtn(true)
    getFormValues(values)
    closeDialog()
  }

  return (
    <>
      <Formik
        initialValues={formValues ?? initialValues}
        form="formRepresentanteProcesal"
        onSubmit={handleSubmit}
        validationSchema={validationSchema(isMonitorio)}
        validateOnMount={false}
        validateOnBlur={validateAfterSubmit}
        validateOnChange={validateAfterSubmit}
      >
        {({ handleSubmit, submitForm }) => (
          <Form
            onSubmit={event => {
              setValidateAfterSubmit(true)
              handleSubmit(event)
            }}
          >
            <Box sx={{ marginTop: '12px' }}>
              <RequiredText />
            </Box>
            <RepresentanteProcesalFormField />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <ButtonPrimaryOutlined onClick={closeDialog}>
                {t('actions.cancel')}
              </ButtonPrimaryOutlined>
              <ButtonSecondary type="submit" onClick={() => submitForm} disabled={disabledAddBtn}>
                {formValues ? t('actions.save') : t('actions.add')}
              </ButtonSecondary>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  )
}
